<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs">

    <!-- GENERAL -->
    <vs-tab v-if="hasPermission('billing.report')" @click="componentCurrent = 'BillingReport'" icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'Billing' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
    </vs-tab>
    <vs-tab v-if="hasPermission('contact.report')" icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Client' : ''"  @click="componentCurrent = 'ClientReport'" >
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
    </vs-tab>
    <vs-tab v-if="hasPermission('matter.report')" icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Matter' : ''" @click="componentCurrent = 'MatterReport'" >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
    </vs-tab>
    <vs-tab v-if="hasPermission('billing.report.revenue')" icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Revenue' : ''" @click="componentCurrent = 'RevenueReport'" >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
    </vs-tab>
    <vs-tab v-if="hasPermission('task.report')" icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Task' : ''" @click="componentCurrent = 'TaskReport'" >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>

    import BillingReport from "./BillingReport";
    import ClientReport from "./ClientReport";
    import MatterReport from "./MatterReport";
    import ProductivityReport from "./ProductivityReport";
    import TaskReport from "./TaskReport";
    import RevenueReport from "./RevenueReport";
    import ComponentGeneral from "./bill/ComponentGeneral";
    import ComponentAgentRecivable from "./bill/ComponentAgentRecivable";
    import ComponentHistoryBill from "./bill/ComponentHistoryBill";
    import ComponentMatterBalanceSummery from "./bill/ComponentMatterBalanceSummery";
    import ComponentInvoicePayments from "./bill/ComponentInvoicePayments";
    import ComponentProductivityClient from "./matter/ComponentContactInformation";
    import ComponentByUser from "./matter/ComponentMatter";
    import ComponentMatterProductivityByUser from "./matter/ComponentMatterResponsible";
    import ComponentRevenue from "./revenue/ComponentRevenue";
    import ComponentOriginatingSolicitorRevenue from "./revenue/ComponentOriginatingSolicitorRevenue";
    import ComponentClientActivity from "./client/ComponentClientActivity";
    import ComponentClientLedger from "./client/ComponentClientLedger";
    import ComponentClientAccountLedger from "./client/ComponentClientAccountLedger";
    import ComponentAccountManagement from "./client/ComponentAccountManagement";
    import ComponentTrustListing from "./client/ComponentTrustListing";
    import ComponentWorkProgress from "./client/ComponentWorkProgress";
    import ComponentBankAccountActivity from "./client/ComponentBankAccountActivity";
    import ComponentMatter from "@/views/reports/matter/ComponentMatter";
    import ComponentMatterResponsible from "@/views/reports/matter/ComponentMatterResponsible";
    import ComponentContactInformation from "@/views/reports/matter/ComponentContactInformation";
    import ComponentProgressByUser from "@/views/reports/task/ComponentProgressByUser";
    import ComponentProductivityByUser from "@/views/reports/task/ComponentProductivityByUser";
    import mixin from '@/views/mixin/mixin'

    export default {
      name: "Reports",
      mixins: [mixin],
      components:{
        BillingReport,
        ClientReport,
        MatterReport,
        ProductivityReport,
        TaskReport,
        RevenueReport,
        ComponentGeneral,
        ComponentAgentRecivable,
        ComponentHistoryBill,
        ComponentMatterBalanceSummery,
        ComponentInvoicePayments,
        ComponentProductivityClient,
        ComponentByUser,
        ComponentMatterProductivityByUser,
        ComponentRevenue,
        ComponentOriginatingSolicitorRevenue,
        ComponentClientActivity,
        ComponentClientLedger,
        ComponentClientAccountLedger,
        ComponentAccountManagement,
        ComponentTrustListing,
        ComponentWorkProgress,
        ComponentBankAccountActivity,
        ComponentMatter,
        ComponentMatterResponsible,
        ComponentContactInformation,
        ComponentProgressByUser,
        ComponentProductivityByUser,
      },
      data(){
        return{
          componentCurrent: 'BillingReport'
        }
      },
      methods:{
        changeTab(val){
          this.componentCurrent = val
        }
      },
      computed: {
        isSmallerScreen () {
          return this.$store.state.windowWidth < 768
        }
      },
      async created() {
        const permissions = await this.$store.state.permissions
        // if (permissions !== undefined) {
        //   if   (this.hasPermission('activity.time-entry.list')) this.type_activity = '1'
        //   else if(this.hasPermission('activity.expense-entry.list')) this.type_activity = '2'
        //   else if(this.hasPermission('activity.expense-entry.category.list')) this.type_activity = '3'
        //   else this.type_activity = '1'
        // }
      }
    }
</script>

<style>
  .title-report{
    color: #3A3DBE !important;
  }
  [dir] .ant-divider-horizontal{
    /*background: #ccc !important;*/
  }
  .vs-card--content{
    margin-bottom: 0 !important;
  }
  .title-card{
    color: darkgray;
  }
  #profile-tabs .vs-tabs--content {
    padding: 0;
  }

  .slide-fade-enter-active {
    opacity: 1;
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease-in-out;
    /*cubic-bezier(1.0, 0.5, 0.8, 1.0)*/
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  [dir] .vs-tabs-position-left .vs-tabs--li{
    z-index: 0;
  }
</style>

